import { type PropsWithChildren, useMemo } from 'react';

import { useRecoilState } from 'recoil';
import { CodeMasterContext } from '@/modules/context/CodeMasterContext';
import { settingState } from '@/state/settingState';

type CodeMasterProviderProps = PropsWithChildren;

export const CodeMasterProvider: React.FC<CodeMasterProviderProps> = (props) => {
  const { children } = props;
  const [setting] = useRecoilState(settingState);
  const temp = useMemo(() => [], []);

  return <CodeMasterContext.Provider value={setting?.codeMasters || temp}>{children}</CodeMasterContext.Provider>;
};
